
import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { CellWithValidator, StickyHeader } from "../../../../components/Table/TableStyles";
import { offsetOneRow, offsetTwoRows, StateStyledCell } from "../../Styles/ParticipationTableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { TextFilter } from "../../../../components/Form/FormStyles";

export function RegistryLinkHeader() {
	return (
		<StickyHeader
			style={{
				...offsetOneRow,
				width: '250px',
				minWidth: '250px',
				maxWidth: '250px'
			}}>
			CC Registry Link
		</StickyHeader>
	)
}

export function RegistryLinkFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.CarbonProjectRegistryLinkValidated ??
						ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({
							...filter,
							CarbonProjectRegistryLinkValidated: e.value
						})
					}
				/>
				<TextFilter
					value={filter?.CarbonProjectRegistryLink ?? ''}
					onChange={(e) =>
						updateFilter({
							...filter,
							CarbonProjectRegistryLink: e.target.value
						})
					}
				/>
			</CellWithValidator>
		</StickyHeader>
	)
}

export function RegistryLinkContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.CarbonProjectRegistryLinkValidated && (
						<ValidatedIcon />
					)}
				</span>
				<span>{ppn.PlantingProject.CarbonProjectRegistryLink}</span>
			</CellWithValidator>
		</StateStyledCell>
	)
}